module.exports = __webpack_public_path__ + "static/media/instagramBlue.c0cac361.svg";